import React from "react";
import "../../generic.css";

class StorePayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      balance: this.props.balance,
      addPmtBtnDisabled: this.props.balance ? false : true,
      paymentMethod: 1,
      amount: this.props.balance,
      nameOnCard: null,
      last4: null,
      approvalCode: null,
      note: null,
      addPmtExpanded: false,
      exceedBalWarning: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.addPayment = this.addPayment.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.balance != prevProps.balance) {
      this.setState({
        balance: this.props.balance,
        amount: this.props.balance,
        addPmtBtnDisabled: this.props.balance ? false : true,
      });
    }
  }
  handleChange(event) {
    const name = event.target.name;

    if (name.startsWith("CB_")) {
      this.setState({ addPmtExpanded: event.target.checked });
      return;
    }

    let val = event.target.value;
    let exceedBalWarning = this.state.exceedBalWarning;
    let addPmtBtnDisabled = this.state.addPmtBtnDisabled;
    if (name === "amount") {
      if (!val || val.trim().length === 0) {
        this.setState({ amount: null, addPmtBtnDisabled: true });
        return;
      }

      let amount = parseFloat(val);
      if (isNaN(amount)) {
        return;
      }
      addPmtBtnDisabled = false;
      if (amount > this.state.balance) {
        exceedBalWarning = "Exceed balance";
      } else {
        exceedBalWarning = null;
      }
    } else if (name === "paymentMethod") {
      val = parseInt(val);
    }
    this.setState({ [name]: val, exceedBalWarning, addPmtBtnDisabled });
  }
  addPayment(event) {
    const payment = {
      amount: this.state.amount,
      typeId: this.state.paymentMethod,
      nameOnCard: this.state.nameOnCard,
      last4: this.state.last4,
      approvalCode: this.state.approvalCode,
      note: this.state.note,
    };
    this.props.callback(payment);
  }
  addPaymentHeader() {
    return (
      <div className="flex-wrapper-ctr">
        <div>
          <input
            type="checkbox"
            name="CB_addPmtExpanded"
            defaultChecked={this.state.addPmtExpanded}
            checked={this.state.addPmtExpanded}
            onChange={this.handleChange}
          ></input>{" "}
        </div>
        <div>
          <b>
            <font color="darkgreen">Add InStore Payment</font>
          </b>
        </div>
        {this.state.addPmtExpanded && (
          <React.Fragment>
            <div className="left-10">
              <input
                type="radio"
                name="paymentMethod"
                value={1}
                checked={this.state.paymentMethod === 1}
                onChange={this.handleChange}
              ></input>{" "}
              Cash/Check
            </div>
            <div className="left-10">
              <input
                type="radio"
                name="paymentMethod"
                value={2}
                checked={this.state.paymentMethod === 2}
                onChange={this.handleChange}
              ></input>
              Debit/Credit
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
  addPaymentSection() {
    if (this.state.addPmtExpanded) {
      const addBtnStyle = this.state.addPmtBtnDisabled
        ? "disabled-green-btn"
        : "green-btn";
      let amountStr;
      if (this.state.amount) {
        amountStr = "" + this.state.amount;
        try {
          const pos = amountStr.indexOf(".");
          if (pos > 0 && amountStr.length - pos > 2) {
            amountStr = this.state.amount.toFixed(2);
          }
        } catch {}
      } else amountStr = "";

      return (
        <div className="left-20">
          <div className="twocol-form">
            <div>
              Amount<font color="red">*</font>:
            </div>
            <div>
              <input
                type="text"
                size="6"
                name="amount"
                inputMode="decimal"
                value={amountStr}
                onChange={this.handleChange}
              ></input>
              &nbsp;{<font color="orange">{this.state.exceedBalWarning}</font>}
            </div>
            {this.state.paymentMethod === 2 && (
              <React.Fragment>
                <div>Name on Card:</div>
                <div>
                  <input
                    type="text"
                    size="20"
                    name="nameOnCard"
                    value={this.state.nameOnCard || ""}
                    onChange={this.handleChange}
                  ></input>
                </div>
                <div>Last4:</div>
                <div>
                  <input
                    type="text"
                    size="6"
                    name="last4"
                    value={this.state.last4 || ""}
                    onChange={this.handleChange}
                  ></input>
                </div>
                <div>Approval Code:</div>
                <div>
                  <input
                    type="text"
                    size="20"
                    name="approvalCode"
                    value={this.state.approvalCode || ""}
                    onChange={this.handleChange}
                  ></input>
                </div>
              </React.Fragment>
            )}
            <div>Note:</div>
            <div>
              <input
                type="text"
                name="note"
                value={this.state.note || ""}
                onChange={this.handleChange}
              ></input>
            </div>
          </div>
          <div className="top10b15">
            <button
              className={addBtnStyle}
              name="addPmt"
              onClick={this.addPayment}
              disabled={this.state.addPmtBtnDisabled}
            >
              Add Payment
            </button>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        {this.addPaymentHeader()}
        {this.addPaymentSection()}
      </div>
    );
  }
}
export default StorePayment;
